import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const call = (name, payload) => httpsCallable(functions, name)(payload).then((result) => result.data);

export const summarizeNote = (noteId, requestId) => call('summarizeNote', { noteId, requestId });
export const getAiUsageStatus = () => call('getAiUsageStatus', {});
